import Footer from "./Footer";
import FooterV2 from "./FooterV2";

export { Footer, FooterV2 };

export default Footer;
